var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70906 8.02987L20.6337 2.05499C21.4441 1.78485 22.2152 2.55587 21.945 3.36631L15.9701 21.2909C15.6922 22.1248 14.5678 22.2561 14.1052 21.5088L11.216 16.8416C10.784 16.1438 10.8043 15.2569 11.2678 14.5795L15.2702 8.7298L9.42047 12.7322C8.74313 13.1957 7.85617 13.216 7.15835 12.784L2.49122 9.89481C1.74389 9.43218 1.87522 8.30782 2.70906 8.02987Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.6914850683fd5f6b27e75c5e408e2c69.svg";
export { ForwardRef as ReactComponent };